/**
 * Which backend the app talks to, derived from the API base URL (VITE_ADNUNTIUS_API_BASE).
 * Switch with `npm run envLoc | envDev | envProd`.
 */

export type ApiEnvironment = 'local' | 'dev' | 'staging' | 'prod'

const API_BASE = import.meta.env.VITE_ADNUNTIUS_API_BASE || 'https://api.dev.adnuntius.com/api'

function detectApiEnvironment(url: string): ApiEnvironment {
  const host = new URL(url).hostname
  if (host === 'localhost' || host === '127.0.0.1') return 'local'
  if (host.includes('staging')) return 'staging'
  if (host.includes('dev')) return 'dev'
  return 'prod'
}

export const apiEnvironment = detectApiEnvironment(API_BASE)
export const apiHost = new URL(API_BASE).host

/** Remote MCP server URL that AI agents connect to. */
export const mcpUrl = `${API_BASE.replace(/\/$/, '')}/mcp`

/** True when the UI itself is served from the developer's machine. */
export const isLocalhostUi = ['localhost', '127.0.0.1'].includes(window.location.hostname)
